var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00016 2.6665C2.5274 2.6665 1.3335 3.86041 1.3335 5.33317V11.3332C1.3335 12.4377 2.22893 13.3332 3.3335 13.3332H9.3335H10.0002H10.6668H12.6668C13.7714 13.3332 14.6668 12.4377 14.6668 11.3332V8.6665C14.6668 7.19374 13.4729 5.99984 12.0002 5.99984H10.6668V5.33317C10.6668 3.86041 9.47292 2.6665 8.00016 2.6665H4.00016ZM10.6668 7.33317V11.9998H12.6668C13.035 11.9998 13.3335 11.7014 13.3335 11.3332V8.6665C13.3335 7.93012 12.7365 7.33317 12.0002 7.33317H10.6668ZM9.3335 5.99984V5.33317C9.3335 4.59679 8.73654 3.99984 8.00016 3.99984H4.00016C3.26378 3.99984 2.66683 4.59679 2.66683 5.33317V11.3332C2.66683 11.7014 2.96531 11.9998 3.3335 11.9998H9.3335V6.6665V5.99984Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 11.3332C4.6665 10.965 4.96498 10.6665 5.33317 10.6665H6.6665C7.03469 10.6665 7.33317 10.965 7.33317 11.3332V13.3332H4.6665V11.3332Z",
    fill: "#FF865C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.3335C5.63181 5.3335 5.33333 5.63197 5.33333 6.00016V6.66683H4.66667C4.29848 6.66683 4 6.96531 4 7.3335C4 7.70169 4.29848 8.00016 4.66667 8.00016H5.33333V8.66683C5.33333 9.03502 5.63181 9.3335 6 9.3335C6.36819 9.3335 6.66667 9.03502 6.66667 8.66683V8.00016H7.33333C7.70152 8.00016 8 7.70169 8 7.3335C8 6.96531 7.70152 6.66683 7.33333 6.66683L6.66667 6.66683V6.00016C6.66667 5.63197 6.36819 5.3335 6 5.3335Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterBuilding);
export default __webpack_public_path__ + "static/media/center-building.fd61b52ce8483cf1f2b656ff87cbc92f.svg";
export { ForwardRef as ReactComponent };